export const GetOverboreValues = () => {
    const result = [
        {
            label: "No overbore",
            value: "0"
        },
        {
            label: "0.010 inches",
            value: "0.010"
        },
        {
            label: "0.020 inches",
            value: "0.020"
        },
        {
            label: "0.030 inches",
            value: "0.030"
        },
        {
            label: "0.040 inches",
            value: "0.040"
        },
        {
            label: "0.050 inches",
            value: "0.050"
        },
        {
            label: "0.060 inches",
            value: "0.060"
        },
        {
            label: "0.070 inches",
            value: "0.070"
        },
        {
            label: "0.080 inches",
            value: "0.080"
        },
        {
            label: "0.090 inches",
            value: "0.090"
        },
    ];
    return result;
}

export const GetOverboreValuesInMM = () => {
    const result = [
        {
            label: "No overbore",
            value: "0"
        },
        {
            label: "0.254 millimeters",
            value: "0.254"
        },
        {
            label: "0.508 millimeters",
            value: "0.508"
        },
        {
            label: "0.762 millimeters",
            value: "0.762"
        },
        {
            label: "1.106 millimeters",
            value: "1.106"
        },
        {
            label: "1.270 millimeters",
            value: "1.270"
        },
        {
            label: "1.524 millimeters",
            value: "1.524"
        },
        {
            label: "1.778 millimeters",
            value: "1.778"
        },
        {
            label: "2.032 millimeters",
            value: "2.032"
        },
        {
            label: "2.286 millimeters",
            value: "2.286"
        },
    ];
    return result;
}

export const GetNumCylinders = () => {
    const result = [
        {
            label: "Choose a number",
            value: "0"
        }
    ];

    for (let i = 2, ilen = 12; i <= ilen; i++) {
        result.push({ label: `${i}`, value: i })
    }
    return result
}

export const Calculate = (requestObject) => {

    requestObject ??= {};

    const result = {
        isValid: false,
        errors: [],
        result: null,
        cubicInchesResult: null,
        litersResult: null
    }

    requestObject.numCylinders = parseInt(`${requestObject.numCylinders}`);
    requestObject.bore = parseFloat(`${requestObject.bore}`);
    requestObject.stroke = parseFloat(`${requestObject.stroke}`);
    requestObject.overbore = parseFloat(`${requestObject.overbore}`);

    if (Validate(requestObject, result)) {
        return result;
    }

    if (requestObject.isMetric) {
        requestObject.bore = ConvertMmToInches(requestObject.bore);
        requestObject.stroke = ConvertMmToInches(requestObject.stroke);
    }

    result.result = Math.round((requestObject.numCylinders * Math.PI * Math.pow(((requestObject.bore + requestObject.overbore) / 2), 2) * requestObject.stroke) * 100) / 100;
    result.cubicInchesResult = `${result.result} cubic inches`;

    result.litersResult = `${Math.round(((result.result) / 61.0237) * 1000) / 1000} litres`;
    result.label = `${requestObject.numCylinders} x π x (${requestObject.bore}/2)² x ${requestObject.stroke} = `
    result.isValid = true;
    return result;
}


export const ConvertFromMetric = (requestObject) => {
    if (requestObject.isMetric) {
        requestObject.bore = ConvertMmToInches(requestObject.bore);
        requestObject.stroke = ConvertMmToInches(requestObject.stroke);
    }
}

export const ConvertMmToInches = (number) => {
    return (Math.round((number / 25.4) * 100) / 100);
}

const Validate = (requestObject, result) => {
    const CheckForNaN = (number, id) => {
        if (isNaN(number)) {
            result.errors.push({
                id: id,
                message: "Please enter a valid number"
            })
        }
    }

    CheckForNaN(requestObject.numCylinders, "numCylinders");
    CheckForNaN(requestObject.bore, "bore");
    CheckForNaN(requestObject.stroke, "stroke");
    CheckForNaN(requestObject.overbore, "overbore");

    if (!requestObject.isMetric) {
        if (requestObject.bore < 2 || requestObject.bore > 8) {
            result.errors.push({
                id: "bore",
                message: "Please enter a bore diameter between 2 and 8 inches"
            })
        }
        if (requestObject.stroke < 1 || requestObject.stroke > 12) {
            result.errors.push({
                id: "stroke",
                message: "Please enter a stroke length between 1 and 12 inches"
            })
        }
    }
    else {
        if (requestObject.bore < 50.8 || requestObject.bore > 203.2) {
            result.errors.push({
                id: "bore",
                message: "Please enter a bore diameter between 50.8 and 203.2 millimeters"
            })
        }
        if (requestObject.stroke < 25.4 || requestObject.stroke > 304.8) {
            result.errors.push({
                id: "stroke",
                message: "Please enter a stroke length between 25.4 and 304.8 millimeters"
            })
        }
    }
    if (requestObject.numCylinders < 2 || requestObject.numCylinders > 12) {
        result.errors.push({
            id: "numCylinders",
            message: "Number of cylinders should be between 2 and 12"
        })
    }

    if (!requestObject.isMetric) {
        let validOverboreValues = GetOverboreValues().map(x => parseFloat(x.value));
        if (!validOverboreValues.some(x => x == requestObject.overbore)) {
            result.errors.push({
                id: "overbore",
                message: "Please enter a valid overbore value"
            })
        }
    }
    else {
        let validOverboreValues = GetOverboreValuesInMM().map(x => parseFloat(x.value));
        if (!validOverboreValues.some(x => x == requestObject.overbore)) {
            result.errors.push({
                id: "overbore",
                message: "Please enter a valid overbore value"
            })
        }
    }
    return result.errors.length > 0
}
